import React from 'react';
import { scoreSystemKeys, scoreSystemNames, } from '@crimp/lib-score-systems';
import Form from 'antd/lib/form';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
var InputScoreSystem = function (props) { return (React.createElement(Form.Item, { label: 'Score format', extra: 'Cannot be changed after round is created', colon: false }, props.form.getFieldDecorator('scoreSystem', {
    initialValue: props.initialValue || 'ifsc_tz',
    rules: [{
            required: true,
            message: 'Please set the score format for this round',
        }, {
            type: 'string',
        }],
})(React.createElement(Select, { size: 'large', disabled: props.isDisabled }, scoreSystemKeys.map(function (scoreSystemKey) { return (React.createElement(Select.Option, { key: scoreSystemKey, value: scoreSystemKey }, scoreSystemNames[scoreSystemKey])); }))))); };
export default InputScoreSystem;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormRoundPage/FormRound/InputScoreSystem.tsx
// module id = 1187
// module chunks = 0